import "./index.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "./store/index.ts";
import { Provider } from "react-redux";
import { QueryClientProvider } from "@tanstack/react-query";
import { WalletProvider } from "./context/WalletContext.tsx";
import { queryClient } from "./services/queryClient";
import ThemeProvider from "./components/ThemeProvider.tsx";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Provider store={store}>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <WalletProvider>
            <PersistGate loading={null} persistor={persistor}>
              <App />
            </PersistGate>
          </WalletProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </Provider>
  </StrictMode>,
);
